<div class="backoffice-companies-container">
  <div class="filter-section">
    <mat-form-field>
      <mat-label>Filtrar</mat-label>
      <input matInput (keyup)="applyFilter($event)" #input />
    </mat-form-field>
  </div>
  <table mat-table matSort [dataSource]="dataSource" class="mat-elevation-z8">
    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef>ID</th>
      <td mat-cell *matCellDef="let element">{{ element.id }}</td>
    </ng-container>
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>Nombre</th>
      <td mat-cell *matCellDef="let element">{{ element.name }}</td>
    </ng-container>
    <ng-container matColumnDef="company_name">
      <th mat-header-cell *matHeaderCellDef>Nombre empresa</th>
      <td mat-cell *matCellDef="let element">{{ element.company_name }}</td>
    </ng-container>

    <ng-container matColumnDef="business_name">
      <th mat-header-cell *matHeaderCellDef>Nombre CompaÃ±Ã­a</th>
      <td mat-cell *matCellDef="let element">{{ element.business_name }}</td>
    </ng-container>
    <ng-container matColumnDef="business_group">
      <th mat-header-cell *matHeaderCellDef>Grupo CompaÃ±Ã­a</th>
      <td mat-cell *matCellDef="let element">{{ element.business_group }}</td>
    </ng-container>
    <ng-container matColumnDef="email">
      <th mat-header-cell *matHeaderCellDef>Email</th>
      <td mat-cell *matCellDef="let element">{{ element.email }}</td>
    </ng-container>
    <ng-container matColumnDef="fiscal_address">
      <th mat-header-cell *matHeaderCellDef>DirecciÃ³n</th>
      <td mat-cell *matCellDef="let element">{{ element.fiscal_address }}</td>
    </ng-container>

    <ng-container matColumnDef="phone">
      <th mat-header-cell *matHeaderCellDef>TelÃ©fono</th>
      <td mat-cell *matCellDef="let element">{{ element.phone }}</td>
    </ng-container>

    <ng-container matColumnDef="tax_id">
      <th mat-header-cell *matHeaderCellDef>CIF</th>
      <td mat-cell *matCellDef="let element">{{ element.tax_id }}</td>
    </ng-container>
    <ng-container matColumnDef="total_cowings">
      <th mat-header-cell *matHeaderCellDef>Cowings totales</th>
      <td mat-cell *matCellDef="let element">{{ element.total_cowings }}</td>
    </ng-container>
    <ng-container matColumnDef="state_id">
      <th mat-header-cell *matHeaderCellDef>Estado</th>
      <td mat-cell *matCellDef="let element">
        <mat-select
          [(ngModel)]="element.state_id"
          name="food"
          (selectionChange)="changeStatus($event, element.id)"
        >
          <mat-option *ngFor="let state of companyStates" [value]="state.id">
            {{ state.name }}
          </mat-option>
        </mat-select>
      </td>
    </ng-container>
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef>Acciones</th>
      <td mat-cell *matCellDef="let element">
        <div class="actions">
          <div (click)="editCompany(element)">
            <img [src]="getEditIcon" alt="" />
          </div>
          <div (click)="deleteCompany(element)">
            <img [src]="getDeleteIcon" alt="" />
          </div>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" colspan="4">
        No data matching the filter "{{ input.value }}"
      </td>
    </tr>
  </table>
  <mat-paginator [length]="resultsLength" [pageSize]="20"></mat-paginator>
</div>
